import { FC } from 'react';

interface IAudioIconProps {
  stroke?: string;
  color?: string;
}

const AudioIcon: FC<IAudioIconProps> = (props) => {
  const { stroke, color } = props;
  return (
    <svg
      width="18"
      height="20"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill={stroke ?? 'none'}
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color ?? '#000000'}
        stroke="none"
      >
        <path d="M1881 4921 c-51 -18 -90 -54 -557 -523 -488 -489 -503 -505 -518 -558 -15 -50 -16 -225 -14 -1736 l3 -1679 33 -68 c24 -49 48 -79 83 -107 90 -71 75 -70 806 -70 l654 0 -34 42 c-19 24 -42 58 -51 75 l-16 33 -613 2 -612 3 -33 23 c-18 13 -41 41 -52 62 -20 39 -20 65 -20 1684 l0 1645 408 3 c405 3 407 3 460 27 69 31 137 106 157 174 12 41 15 122 15 444 l0 393 1035 0 c1140 0 1085 3 1125 -62 20 -32 20 -48 20 -852 l0 -818 38 6 c20 4 54 12 75 17 l37 10 -2 817 -3 817 -28 57 c-29 60 -78 106 -144 136 -35 16 -117 17 -1118 19 -1035 2 -1082 2 -1134 -16z" />
        <path d="M2280 3965 l0 -75 790 0 790 0 0 75 0 75 -790 0 -790 0 0 -75z" />
        <path d="M2280 3515 l0 -75 790 0 790 0 0 75 0 75 -790 0 -790 0 0 -75z" />
        <path d="M1240 3065 l0 -75 1308 2 1307 3 3 73 3 72 -1311 0 -1310 0 0 -75z" />
        <path d="M4315 2931 c-121 -26 -493 -105 -827 -176 l-608 -129 0 -816 0 -815 -103 0 c-89 0 -109 -3 -157 -26 -168 -80 -258 -230 -248 -414 4 -71 10 -95 41 -158 133 -268 492 -321 687 -100 53 61 88 137 100 220 6 41 10 430 10 969 l0 900 168 37 c92 20 322 70 512 112 189 41 348 75 352 75 4 0 8 -282 8 -627 l0 -628 -108 0 c-101 0 -111 -2 -173 -32 -132 -65 -228 -206 -237 -348 -14 -224 132 -410 350 -447 221 -38 435 125 468 357 15 111 13 2095 -2 2094 -7 0 -112 -22 -233 -48z" />
        <path d="M1240 2615 l0 -75 745 0 745 0 0 75 0 75 -745 0 -745 0 0 -75z" />
        <path d="M1240 2165 l0 -75 745 0 745 0 0 75 0 75 -745 0 -745 0 0 -75z" />
        <path d="M1240 1715 l0 -75 745 0 745 0 0 75 0 75 -745 0 -745 0 0 -75z" />
        <path d="M1240 1215 l0 -75 745 0 745 0 0 75 0 75 -745 0 -745 0 0 -75z" />
      </g>
    </svg>
  );
};

export default AudioIcon;
